import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {plainToClass} from 'class-transformer';
import {ProjectVehicleParametersOverrideApiModel} from '../models/project-vehicle-parameters-override.api-model';

@Injectable()
export class ProjectVehicleParametersOverrideRestService {
  private readonly resource: string = '/project_vehicle_parameters_overrides';

  constructor(private http: HttpClient) {
  }

  public create(payload: Partial<ProjectVehicleParametersOverrideApiModel>): Observable<ProjectVehicleParametersOverrideApiModel> {
    return this.http.post<ProjectVehicleParametersOverrideApiModel>(environment.apiUrl + this.resource, payload)
      .pipe(map((result: ProjectVehicleParametersOverrideApiModel) => plainToClass(ProjectVehicleParametersOverrideApiModel, result)));
  }

  public patch(idOrIri: string | number, payload: Partial<ProjectVehicleParametersOverrideApiModel>): Observable<ProjectVehicleParametersOverrideApiModel> {
    const endpoint = typeof idOrIri === 'string' && idOrIri.startsWith('/api/')
      ? idOrIri
      : `${this.resource}/${idOrIri}`;

    return this.http.patch<ProjectVehicleParametersOverrideApiModel>(environment.apiUrl + endpoint, payload)
      .pipe(map((result: ProjectVehicleParametersOverrideApiModel) => plainToClass(ProjectVehicleParametersOverrideApiModel, result)));
  }

  public delete(idOrIri: string | number): Observable<void> {
    const endpoint = typeof idOrIri === 'string' && idOrIri.startsWith('/api/')
      ? idOrIri
      : `${this.resource}/${idOrIri}`;

    return this.http.delete<void>(environment.apiUrl + endpoint);
  }
}
